import React from "react";
import { Box, Tabs, Tab, Stack,Button } from "@mui/material";
import { useState } from "react";
import TabPanel from "../../../components/TabPanel";
import { getTransactionDocRelatedRecords } from "../../../api/transaction-type";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import {
  billRelatedRecordsPayment,
  billRelatedRecordsPurchaseOrder,
  billRelatedRecordsReimbursements,
  billRelatedRecordsTransformations,
} from "../../../config/grid-column-defs";
import useSnackbar from "../../../hooks/useSnackbar";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getTransactionNotAvailable } from "../../../config/grid-value-formatters";

export default function CreditCardRelatedRecords() {
  /*----------------Tabs-----------------*/
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [tabIndexRelatedRecord, setTabIndexRelatedRecord] = useState(0);

  async function getTransactionRelatedRecordsData(limit, offset) {
    try {
      const { data } = await getTransactionDocRelatedRecords(user.token, {
        id: params.docNo,
        limit, offset,
      });
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }
  return (
    <>
      <Box className="viewDetilsBox">
        <Tabs
          value={tabIndexRelatedRecord}
          // onChange={handleChange}
          onChange={(e, nv) => {
            setTabIndexRelatedRecord(nv);
          }}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          className="tabs-sub-bkg"
        >
         
          <Tab label="Reimbursements" /> 
        </Tabs>

        {/* Reimbursements */}
        <TabPanel value={tabIndexRelatedRecord} index={0}>
        
          <AgGridPaginatedTable
            getTableRows={undefined}
            columns={billRelatedRecordsReimbursements}
            refreshCounter={0}
          />
        </TabPanel>

      </Box>
    </>
  );
}
